import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

// Project imports
import { selectUiBranding } from "store/reducers/branding";

type OriginalIcons = {
  icon?: string;
  shortcut?: string;
};

export function useBrandingDomSideEffects() {
  // --- Hooks --- //
  const ui = useSelector(selectUiBranding);
  // --- State & refs --- //
  const originalTitleRef = useRef<string | null>(null);
  const originalIconsRef = useRef<OriginalIcons | null>(null);

  // Capture originals once
  useEffect(() => {
    if (originalTitleRef.current === null) {
      originalTitleRef.current = document.title;
    }
    if (originalIconsRef.current === null) {
      const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
      const shortcut = document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');
      originalIconsRef.current = {
        icon: icon?.href,
        shortcut: shortcut?.href,
      };
    }
  }, []);

  // Title
  useEffect(() => {
    if (ui.appName && ui.appName !== "" && ui.appName !== originalTitleRef.current) {
      document.title = ui.appName;
    } else if (originalTitleRef.current) {
      document.title = originalTitleRef.current;
    }
  }, [ui.appName]);

  // Favicon
  useEffect(() => {
    const faviconUrl = ui.assets.favicon?.url;
    if (faviconUrl) {
      upsertLink("icon", faviconUrl, "image/png");
      upsertLink("shortcut icon", faviconUrl, "image/png");
    } else if (originalIconsRef.current) {
      if (originalIconsRef.current.icon) {
        upsertLink("icon", originalIconsRef.current.icon);
      }
      if (originalIconsRef.current.shortcut) {
        upsertLink("shortcut icon", originalIconsRef.current.shortcut);
      }
    }
  }, [ui.assets.favicon?.url]);
}

// --- Helper functions --- //
function upsertLink(rel: string, href: string, type?: string) {
  let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
  if (type) el.type = type;
}
